module.exports = __webpack_public_path__ + "media/images/flags/4x3/grl-9a54143f65b02e2736707863c58a92b7.svg";